import { Link } from "@mui/material"
import { useTranslation } from "react-i18next"

const Copyright = () => {
	const { t } = useTranslation()
	return (
		<span>
			&copy;2021 {t("title", { ns: "copyright" })}
			<Link
				target="_blank"
				rel="noopener"
				href="https://plick.eu/"
				underline="hover"
				color="inherit"
				aria-label={t("accessibilityLabel", { ns: "copyright" })}
			>
				{" "}
				PayDo S.p.A{" "}
			</Link>
		</span>
	)
}

export default Copyright
